export default "__VITE_ASSET__DZMrPC7o__"